import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayeeStoreFrontinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9.5 21v-6h5v6m5.5 0v-9.051M4 21v-9.051M22 21H2M7 9.5a2.5 2.5 0 0 1-5 0V8.33a1 1 0 0 1 .093-.42l1.742-3.752A2 2 0 0 1 5.649 3H18.35a2 2 0 0 1 1.814 1.158l1.742 3.752a1 1 0 0 1 .093.42V9.5a2.5 2.5 0 0 1-5 0"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M17 9.5a2.5 2.5 0 0 1-5 0m0 0a2.5 2.5 0 0 1-5 0"
	})]
});
export default SvgPayeeStoreFrontinline;
